import { render, staticRenderFns } from "./EmissionsData.vue?vue&type=template&id=746b2573&"
import script from "./EmissionsData.vue?vue&type=script&lang=ts&"
export * from "./EmissionsData.vue?vue&type=script&lang=ts&"
import style0 from "./EmissionsData.vue?vue&type=style&index=0&id=746b2573&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports